import { ApplicationInvoiceFormData } from "../../../hooks/useApplicationInvoice";
import { Box, Typography } from "@mui/material";

interface InvoiceDataDisplayProps {
  formData: ApplicationInvoiceFormData;
}

/**
 * Komponent wyświetlający dane faktury w trybie readonly
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko prezentacja danych
 */
export default function InvoiceDataDisplay({ formData }: InvoiceDataDisplayProps) {
  return (
    <Box sx={{ p: 1.5, bgcolor: "grey.50", borderRadius: 1 }}>
      <Typography variant="body2" sx={{ fontSize: "0.875rem", fontWeight: 500, mb: 0.5 }}>
        {formData.invoiceName}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
        {formData.invoiceStreet} {formData.invoiceHouseNumber}
        {formData.invoiceLocalNumber && `/${formData.invoiceLocalNumber}`}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
        {formData.invoicePostalCode} {formData.invoiceCity}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
        NIP: {formData.invoiceTaxId}
      </Typography>
    </Box>
  );
}
